// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__V-eEb","spinner":"Loader_spinner__D-PSW"};